const data =[



  {
      name:"Process Elements",
      children:[
        {
          name:"BusinessTask",
          children:null,
          display:"Business Task",
          node:"RegularNode"
        },
        {
          name:"Condition",
          display:"Condition",
          children:null,
          node:"ConditionNode"
        },

        {
          name:"RepeatForEachItem",
          display:"Repeat For Each Item",
          children:null,
          node:"LoopNode",
        },
        {
          name:"RepeatForCount",
          display:"Repeat for Count",
          children:null,
          node:"LoopNode",
        },

      
      ]
    },


    {
      name:"File",
      children:[
        {
          name:"ReadExcelSheet",
          display:"Read Excel Sheet",
          children:null,
          node:"FileNode"
        },
        {
          name:"WriteExcelSheet",
          display:"Write Excel Sheet",
          children:null,
          node:"FileNode"
        },
        {
          name:"ReadText",
          display:"Read File (Text)",
          children:null,
          node:"FileNode",
        },
        {
          name:"ReadLines",
          display:"Read File (Lines)",
          children:null,
          node:"FileNode",
        },
        {
          name:"WriteText",
          display:"Write File (Text)",
          children:null,
          node:"FileNode",
        }
      ]
  
      },
    

    {
      name:"Email",
      children:[
        {
          name:"SendEmail",
          display:"Send Email",
          children:null,
          node:"EmailNode"
        },
        {
          name:"ReadEmail",
          display:"Read Email",
          children:null,
          node:"EmailNode"
        },
  
      ]
      },
  
      {
        name:"Physical Work",
        children:[
          {
            name:"PaperWork",
            display:"Paper Work",
            children:null,
            node:"RegularNode"
          },
          {
            name:"Lift Item(s)",
            display:"Lift Item(s)",
            children:null,
            node:"RegularNode"
          },
          {
            name:"Send Postal Mail",
            display:"Send Postal Mail",
            children:null,
            node:"RegularNode"
          },
          {
            name:"Calculation",
            display:"Calculate",
            children:null,
            node:"RegularNode"
          },
          {
            name:"Install Equipment",
            display:"Install Equipment",
            children:null,
            node:"RegularNode"
          },
          {
            name:"Commute/Travel",
            display:"Commute/Travel",
            children:null,
            node:"RegularNode"
          },
    
        ]
        },
    
      {
        name:"Communications",
        children:[
          {
            name:"TelephoneCall",
            display:"Make a Call",
            children:null,
            node:"RegularNode"
          },
    
          {
            name:"ReceiveCall",
            display:"Receive a Call",
            children:null,
            node:"RegularNode"
          },
          {
            name:"TextMessage",
            display:"Text Message",
            children:null,
            node:"RegularNode"
          },
          {
            name:"Meet",
            display:"Meet",
            children:null,
            node:"RegularNode"
          },
          {
            name:"Conduct Conference",
            display:"Conduct Conference",
            children:null,
            node:"RegularNode"
          },

        ]
        },
        {
          name:"Miscellaneous",
          children:[
            {
              name:"Mobile App",
              display:"Mobile App",
              children:null,
              node:"RegularNode"
            },
            {
              name:"General",
              display:"General",
              children:null,
              node:"RegularNode"
            },
          ]
        }
      
      
    
  ]



  
  
  
  

  export default data;
  